// a redux slice to manage case
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AppPermission {
  Case: string[];
  User: string[];
}

const initialState: AppPermission = {
  Case: ["Read"],
  User: ["Read"]
};

export const appPermissionSlice = createSlice({
  name: "appPermission",
  initialState,
  reducers: {
    setAppPermission: (state, action: PayloadAction<any>) => {
      return { ...state, ...action.payload };
    },
    resetAppPermission: () => {
      return initialState;
    },
  },
});

export const { setAppPermission, resetAppPermission } = appPermissionSlice.actions;

export default appPermissionSlice.reducer;
